export default __webpack_public_path__ + "static/media/header.3ce00450.jpg";